<template>
    <v-card style="cursor: default; user-select: none;" light min-width="480">
        <v-card-text @click.stop="autofocusOtpInputs()">
            <page-heading :text="email ? $t(pageTranslationText.titleEmail) : $t(pageTranslationText.title)"></page-heading>
            <div v-if="mobile.via === 'sms'">
                {{ $t(pageTranslationText.smsSubtitle, {mobile: mobile.mobile || $store.state.auth.maskedMobile}) }}
            </div>
          <div v-else-if="mobile.via === 'whatsapp'">
            <v-icon color="success" small>mdi-whatsapp</v-icon> {{ $t(pageTranslationText.whatsappSubtitle, {mobile: mobile.mobile || $store.state.auth.maskedMobile}) }}
          </div>
            <div v-else-if="email || mobile.via === 'email'">
                {{ $t(pageTranslationText.emailSubtitle, {email: email}) }}
            </div>
            <div v-else>
                {{ $t(pageTranslationText.callSubtitle, {mobile: mobile.mobile || $store.state.auth.maskedMobile}) }}
            </div>
            <div class="title text-center my-5" v-if="!isTokenLogin">
                {{ email ? '' : '(+' + mobile.country.mobilecountrycode + ')' }}{{ email ? email : mobile.mobile }}
                <v-btn :disabled="loading"
                       @click="edit()"
                       color="primary"
                       text
                >Edit
                </v-btn>
            </div>
            <div class="title my-5 text-center" v-if="isTokenLogin && mobile.via==='email'">
                {{$store.state.auth.maskedEmail }}
            </div>
            <div class="title my-5 text-center" v-else-if="isTokenLogin">
                {{ email ? email : $store.state.auth.maskedMobile }}
            </div>
            <small>{{ $t('components.otp.one_time_pin') }}</small>
            <otp-inputs @submit="submitOtp($event)" ref="otpInputs"></otp-inputs>
            <small :style="'color:' + errorColor"
                   v-if="!!errors && errors.length > 0"
            >{{errors[0]}}
            </small>

          <small>
            {{ $t('components.terms.otp') }} <a @click="visitTerms()">{{ $t('components.terms.review') }}.</a>
          </small>
        </v-card-text>
        <v-card-actions class="pt-0 pb-4 px-4" @click.stop="autofocusOtpInputs()">
          <v-btn :disabled="loading"
                 @click="back()"
                 color="secondary"
                 text
          >{{$t('general.back')}}</v-btn>
            <v-btn :disabled="loading"
                   @click="resend()"
                   color="primary"
                   text
            >{{ mobile.via === 'sms' ?
                $t(pageTranslationText.smsAction) :
                email || mobile.via === 'email'  ? $t(pageTranslationText.emailAction) : mobile.via === 'whatsapp' ? $t(pageTranslationText.whatsappAction) :$t(pageTranslationText.callAction) }}
            </v-btn>
          <v-btn :disabled="loading"
                 @click="useEmail()"
                 color="accent"
                 text
                 v-if="mobile.via === 'sms' ||  mobile.via === 'call'"
          >{{ $t('components.verify_mobile.use_email') }}
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading"
                   @click="submitOtp($refs.otpInputs.code.join(''))"
                   color="primary"
                   large
            >{{$t('general.continue')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import PageHeading from "../framework/PageHeading";
    import removeautocompletes from "../../mixins/removeautocompletes";
    import OtpInputs from "./OtpInputs";

    export default {
        components: {
            PageHeading,
            OtpInputs
        },
        mixins: [removeautocompletes],
        name: "Otp",
        props: {
            submitWhenComplete: {
                type: Boolean,
                default: true
            },
            count: {
                type: Number,
                default: 6
            },
            errors: {
                type: [Array, null],
                default: () => [],
            },
            mobile: {
                required: true,
                type: Object
            },
            loading: {
                type: Boolean,
                default: false
            },
            pageTranslationText: {
                required: true,
                type: Object
            },
            isTokenLogin: {
                type: Boolean,
                default: false
            },
            email : {type:String}
        },
        data: function () {
            return {
                errorColor: this.$vuetify.theme.defaults.light.error,
            }
        },
        computed:{

        },
        methods: {
            submitOtp(event) {
                this.$emit('submit', event);
            },
            resend() {
                this.code = [];
                this.$emit('resend', this.email ? 'email' : this.mobile.via);
            },
            edit() {
                this.$emit('edit');
            },
            autofocusOtpInputs() {
              this.$refs.otpInputs.autofocus();
            },
            back(){
              this.$emit('back');
            },
            useEmail(){
              this.$emit('email');
            },
            visitTerms(){
              window.open('https://fitt.ai/privacy','_blank');
            }
        }
    }
</script>

<style type="scss">
    .otp-center-text input {
        text-align: center !important;
    }

    .remove-blinking input {
        caret-color: transparent
    }
</style>
